export enum ETeamToastPosition {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom'
}
